import { useQuery } from '@tanstack/react-query';

import { payCalendarsService, useToast } from '@aslanpay/portal-common-lib';

const useFetchPayCalendarByFriendlyId = (friendlyId?: string, enabled = true) => {
  const toast = useToast();

  return useQuery(
    ['fetchPayCalendarByFriendlyId', friendlyId],
    async () => {
      if (!friendlyId) return null;

      const response = await payCalendarsService.fetchPayCalendars({
        friendlyId: [friendlyId],
        page: 0,
        size: 1,
      });

      // Return the first (and should be only) pay calendar found
      return response.list[0] || null;
    },
    {
      enabled: !!friendlyId && enabled,
      onError: () => {
        toast({
          position: 'top-right',
          status: 'error',
          title: 'Something went wrong',
          description: 'Sorry, we failed to fetch the pay calendar information. Please try again.',
        });
      },
    }
  );
};

export default useFetchPayCalendarByFriendlyId;
